var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterLeftLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 434,
    viewBox: "0 0 375 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.02
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.513 339.083L0 226.262L47.314 197.214L195.827 280.396L373.254 181.37V235.41L194.513 339.083Z",
    fill: "#F5A011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.455 375.884L0 264.171V321.377L194.513 433.679L374.29 329.885V272.057L194.455 375.884Z",
    fill: "#F5A011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9429 161.716L97.645 131.476L195.699 191.955L235.172 169.449L106.92 95.9776L154.622 65.4327L285.802 140.581L320.907 120.565L166.547 30.2395L216.899 0L373.255 90.7186V143.309L194.374 244.455L49.9429 161.716Z",
    fill: "#F5A011"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLeftLogo);
export default __webpack_public_path__ + "static/media/footer-left-logo.4c8547ba8763e89436c24f1b1837915b.svg";
export { ForwardRef as ReactComponent };